module.exports = __webpack_public_path__ + "static/media/testimonial (6).6940ca74.png";